<template>
  <div
    class="custom-message-component-image"
    :style="{
      width,
      ...style,
      backgroundSize,
    }"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import {
  CustomMessageImageComponent,
  CustomMessageImageFit,
} from '_c/typings/model/chat/text-node';
import { pushUrl, getWidth } from '@/business/chat/custom-message-util';
import { defineComponent, computed, PropType, toRaw } from 'vue';


export default defineComponent({
  name: 'CustomMessageImage',

  props: {
    attr: {
      type: Object as PropType<CustomMessageImageComponent>,
      required: true,
    },
  },
  setup(props) {
    let scale = 1;
    const attr = toRaw(props.attr);
    if (attr.scale) {
      scale = toRaw(attr.scale);
    }
    const style = {
      height: attr.height ? `${attr.height * scale}px` : '',
      borderRadius: attr.radius ? `${attr.radius * scale}px` : '0px',
      backgroundImage: `url(${attr.url})`,

    };
    const width = getWidth(props.attr.width, scale);
    const backgroundSize = computed(() => {
      if (attr.fit === CustomMessageImageFit.fill) {
        return '100% 100%';
      }
      if (attr.fit === CustomMessageImageFit.cover) {
        return 'cover';
      }
      if (attr.fit === CustomMessageImageFit.contain) {
        return 'contain';
      }
      if (attr.fit === CustomMessageImageFit.fitWidth) {
        return '100% auto';
      }
      if (attr.fit === CustomMessageImageFit.fitHeight) {
        return 'auto 100%';
      }
      if (attr.fit === CustomMessageImageFit.none) {
        return 'auto';
      }
      return 'contain';
    });
    function clickHandle(e: Event): void {
      if (attr.onClick) {
        e.stopPropagation();
        pushUrl(attr.onClick, attr.reportData);
      }
    }
    return {
      backgroundSize,
      width,
      style,
      clickHandle,
    };
  },
});

</script>

<style scoped lang="scss">
.custom-message-component-image {
  background-position: center;
}
</style>
